import React from 'react';
/*import Lottie from "lottie-react";*/
// import scrollAnimation from "./scrollanimation.json";
import bgVideo from '../assets/scarry.mp4'
// import herologo from '../assets/herologo.png';

import pmlogo from '../assets/pmlogo.png';
import aotflogo from '../assets/aotf.png';
import wecalogo from '../assets/weca.png';
import cicplogo from '../assets/cicplogo.png';
import pytchlogo from '../assets/pytchlogo.png';
import bbrdlogo from '../assets/bbrdlogo.png';
import studiologo from '../assets/the-studio-logo.png';

import nightmare from '../../images/vista.png';
import { Row } from 'react-bootstrap';


// const style = {
//     height: 150,
// };

// const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: scrollAnimation,
//     rendererSettings: {
//         preserveAspectRatio: "xMidYMid slice"
//     }
// };

const Home = () => {
    return (
        <><section className="section main-banner" id="top" data-section="section1">
            <video autoPlay muted loop id="bg-video">
                <source src={bgVideo} type="video/mp4" />
            </video>
            <div className="video-overlay header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* <div id="herologo">

                                <img src={herologo} alt="moon" className="herologo" />
                                 <Lottie
                                    animationData={scrollAnimation}
                                    style={style}
                                    options={defaultOptions}
                                /> 
                            </div> */}

                        </div>
                    </div>
                </div>
            </div>
        </section>
            {/* Main Banner Area End */}

            {/* SECTION 1 */}
            <section className="section1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item">
                                        <h3>What we do</h3>
                                        <p>I'm baby activated charcoal asymmetrical taxidermy yr man braid, wolf meditation live-edge occupy. Chia listicle waistcoat, tofu ennui vape authentic schlitz gochujang. Marfa iPhone truffaut cloud bread kombucha tonx four dollar toast hoodie banjo art party kinfolk. Brunch air plant literally, cornhole semiotics snackwave intelligentsia hella. Tattooed raw denim celiac keffiyeh, jianbing cloud bread yr fashion axe tbh banh mi crucifix health goth thundercats. Cornhole humblebrag etsy tofu keytar, tousled kinfolk.</p>
                                        <p>Quinoa polaroid VHS butcher +1. Occupy unicorn plaid DIY, actually vaporware freegan. Disrupt ramps letterpress activated charcoal raclette, prism tilde.</p>
                                        <p>Meditation mustache vinyl plaid knausgaard cray tonx DSA praxis. Master cleanse fam squid godard green juice yuccie. Banjo microdosing keffiyeh yr chartreuse, kale chips pok pok jianbing man braid try-hard.</p>
                                        <div className="main-button">
                                            <div className="scroll-to-section"><a href="/faqs">FIND OUT MORE</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 2  */}
            <section className="section2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-heading">
                                <h2>Supported by</h2>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={pytchlogo} alt="moon" className="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={aotflogo} alt="moon" className="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={wecalogo} alt="moon" className="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={bbrdlogo} alt="moon" className="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={pmlogo} alt="moon" className="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="card-area-content">
                                        <img src={studiologo} alt="moon" className="" />
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <div className="col-lg-12 col-md-12 col-12">
                                    <div className="card-area-content">
                                        <img src={cicplogo} alt="moon" className="" />
                                    </div>
                                </div>
                            </Row>
                            {/* <Row>
                            <div className="col-lg-12 col-md-12 col-12">
                                    <div className="card-area-content">
                                    <img src={bbrdlogo} alt="moon" className="" />
                                    </div>
                                </div>
                            </Row> */}
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 3  */}
            <section className="section3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item">
                                        <h3>What we do</h3>
                                        <p>I'm baby activated charcoal asymmetrical taxidermy yr man braid, wolf meditation live-edge occupy. Chia listicle waistcoat, tofu ennui vape authentic schlitz gochujang. Marfa iPhone truffaut cloud bread kombucha tonx four dollar toast hoodie banjo art party kinfolk. Brunch air plant literally, cornhole semiotics snackwave intelligentsia hella. Tattooed raw denim celiac keffiyeh, jianbing cloud bread yr fashion axe tbh banh mi crucifix health goth thundercats. Cornhole humblebrag etsy tofu keytar, tousled kinfolk.</p>
                                        <p>Quinoa polaroid VHS butcher +1. Occupy unicorn plaid DIY, actually vaporware freegan. Disrupt ramps letterpress activated charcoal raclette, prism tilde.</p>
                                        <p>Meditation mustache vinyl plaid knausgaard cray tonx DSA praxis. Master cleanse fam squid godard green juice yuccie. Banjo microdosing keffiyeh yr chartreuse, kale chips pok pok jianbing man braid try-hard.</p>
                                        <div className="main-button">
                                            <div className="scroll-to-section"><a href="/faqs">FIND OUT MORE</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 align-self-center">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="item">
                                            <img src={nightmare} alt="nightmare" className="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 4  */}
            <section className="section4">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item">
                                        <h3>What we do</h3>
                                        <p>I'm baby activated charcoal asymmetrical taxidermy yr man braid, wolf meditation live-edge occupy. Chia listicle waistcoat, tofu ennui vape authentic schlitz gochujang. Marfa iPhone truffaut cloud bread kombucha tonx four dollar toast hoodie banjo art party kinfolk. Brunch air plant literally, cornhole semiotics snackwave intelligentsia hella. Tattooed raw denim celiac keffiyeh, jianbing cloud bread yr fashion axe tbh banh mi crucifix health goth thundercats. Cornhole humblebrag etsy tofu keytar, tousled kinfolk.</p>
                                        <p>Quinoa polaroid VHS butcher +1. Occupy unicorn plaid DIY, actually vaporware freegan. Disrupt ramps letterpress activated charcoal raclette, prism tilde.</p>
                                        <p>Meditation mustache vinyl plaid knausgaard cray tonx DSA praxis. Master cleanse fam squid godard green juice yuccie. Banjo microdosing keffiyeh yr chartreuse, kale chips pok pok jianbing man braid try-hard.</p>
                                        <div className="main-button">
                                            <div className="scroll-to-section"><a href="/faqs">FIND OUT MORE</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 5  */}
            <section className="section5" id="theFilm">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item">
                                        <h2>THE NIGHTMARE THIEF</h2>
                                        <p>See how nightmares are extracted in this short film starring Grace Chilton, Miranda Wilson and Malik Ibheis, filmed using virtual production at Pytch Studios.
                                            Be one of the first to collect this nightmare by watching the film.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item video-container">
                                        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/Sc0NiH_qn3k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* The Game  */}
            <section className="our-film" id="theCollector">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item">
                                        <h2>THE COLLECTOR</h2>
                                        <p>For Windows PC<br />Meet a collector of nightmares and other occult oddities in the never-ending nightmare of a coma patient’s dream. A first person horror game for Windows built in Unreal Engine.
                                        </p><p>Download the demo for free [here].</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 align-self-center">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="item video-container">
                                        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/GpQHUh-XF-g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;
